module.exports = __webpack_public_path__ + "static/media/MUV.96e5f382.svg";